import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-add-icon',
    templateUrl: './add-icon.component.html',
    styleUrls: ['./add-icon.component.scss']
})
export class AddIconComponent extends AbstractIcon {

    constructor() {
        super();
        this.height = 24;
        this.width = 24;
    }
}
